import React from 'react';
import { IMAGES } from '../../../config/images';

const MainSection = () => {
  return (
    <div id="mainInfoWrapper" className="flex-row">
      <div id="mainTextWrapper" className="flex-column">
        <p id="mainHeadlineText">ПИТЕР ДЛЯ ТЕБЯ!</p>
        <div id="mainDescAndBtnWrapper" className="flex-column">
          <p id="mainDescText">
            Места и маршруты Санкт-Петербурга в одном приложении
          </p>
          <a href="#locationsAndRoutes">
            <p id="toLocationsAndRoutesBtn">К локациям и маршрутам!</p>
          </a>
        </div>
      </div>

      <div className="main-photo-container">
        <img 
          id="mainPhoto" 
          src="/elements/mainPhoto2.png" 
          alt="Главное фото" 
        />
      </div>
    </div>
  );
};

export default MainSection;